import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Accordion from "components/Accordion";
import UsersWorkspaceHeader from "layout/userAdmin/users/UsersWorkspaceHeader";
import UsersWorkspaceTable from "layout/userAdmin/users/UsersWorkspaceTable";

const UsersWorkspace = () => {
  const workspaceInfo = useSelector((state) => state.userAdmin?.workspaceInfo);
  const searchTerm = useSelector((state) => state.userAdmin?.searchTerm);
  const [display, setDisplay] = useState(workspaceInfo);

  useEffect(() => {
    const filtered = {
      ...workspaceInfo,
      workspaces: {
        ...workspaceInfo?.workspaces.map((workspace) => ({
          ...workspace,
          users: workspaceInfo?.workspaces[0].users.filter(
            (user) =>
              user.firstName
                .toLowerCase()
                .includes(searchTerm?.toLowerCase()) ||
              user.lastName.toLowerCase().includes(searchTerm?.toLowerCase()) ||
              user.username.toLowerCase().includes(searchTerm?.toLowerCase())
          ),
        })),
      },
    };
    setDisplay(filtered);
  }, [searchTerm, workspaceInfo]);

  const licensedUsers = display?.workspaces[0]?.users?.filter(
    (user) => user.licensed
  ).length;
  const reservedLicenses =
    display?.workspaces[0]?.reservedLicenses !== -1
      ? display?.workspaces[0]?.reservedLicenses
      : null;

  return (
    <Accordion
      expanded
      header={
        <UsersWorkspaceHeader
          licensedUsers={licensedUsers}
          reservedLicenses={reservedLicenses}
          workspaceName={display?.workspaces[0]?.name}
          nonLicensedUsers={
            display?.workspaces[0]?.users?.length - licensedUsers
          }
        />
      }
      panel={
        <UsersWorkspaceTable
          users={display?.workspaces[0]?.users}
          workspace={display?.workspaces[0]?.name}
          workspaceId={display?.workspaces[0]?.id}
        />
      }
    />
  );
};

export default UsersWorkspace;
